import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { FailedCommandComponent } from "./components/failed-command/failed-command.component";
import { SharedModule } from "../../shared/shared.module";
import { AccordionModule } from "primeng/accordion";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { FailedCommandDetailsComponent } from "./components/failed-command-details/failed-command-details.component";
import { MatNativeDateModule } from "@angular/material/core";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CalendarModule,
    FormsModule,
    AccordionModule,
    DropdownModule,
    MultiSelectModule,
    MatNativeDateModule,
    MatIconModule,
  ],
  declarations: [FailedCommandComponent, FailedCommandDetailsComponent],
  exports: [FailedCommandComponent, FailedCommandDetailsComponent],
  entryComponents: [],
  providers: [],
})
export class FailedCommandModule {}
